// extracted by mini-css-extract-plugin
var _1 = "BulletItemText-moduleBulletItemText__H1J10 Text-moduletext__Z2j5F";
export { _1 as "BulletItemText" }
